export const CALL_EVENTS = {
    CALL_INCOMING: "call:incoming",
    CALL_ACCEPT: "call:accept",
    CALL_REJECT: "call:reject",
    CALL_END: "call:end",
    CALL_CANCEL: "call:cancel",
    CALL_HEARTBEAT: "call:heartbeat",
    CALL_STARTED: "call:started",
    CALL_ENDED: "call:ended",
};

export const CHAT_EVENTS = {
    CHAT_SEND_MESSAGE: "chat:send-message",
    CHAT_NEW_MESSAGE: "chat:new-message",
    CHAT_LEAVE: "chat:leave",
    CHAT_JOIN: "chat:join"
};